<template>
  <div class="w-full">
    <vs-table
      maxHeight="72vh"
      search
      pagination
      max-items="10"
      noDataText=""
      :data="produtos"
    >
      <template slot="header">
        <vs-row vs-w="12">
          <vs-col vs-w="6">
            <h4 style="color: #b4aa99">
              Produtos usados pelos tecnicos de PCO
            </h4>
          </vs-col>
          <vs-col vs-w="6">
            <ModalCadastroProduto @update="getProdutos" />
          </vs-col>
        </vs-row>
      </template>

      <template slot="thead">
        <vs-th sort-key="nome">Produto</vs-th>
        <vs-th sort-key="sigla">Sigla</vs-th>
        <vs-th sort-key="fabricante">Fabricante</vs-th>
        <vs-th sort-key="quantidade_minima">Qtd. Minima</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :state="data[indextr].lixeira == 1 ? 'danger' : ''"
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td :data="data[indextr].nome">{{ data[indextr].nome }}</vs-td>
          <vs-td :data="data[indextr].sigla">{{ data[indextr].sigla }}</vs-td>
          <vs-td :data="data[indextr].fabricante">
            {{ data[indextr].fabricante }}
          </vs-td>
          <vs-td :data="data[indextr].quantidade_minima">
            {{ data[indextr].quantidade_minima }}
          </vs-td>
          <vs-td class="actions">
            <vs-row
              vs-w="12"
              vs-type="flex"
              vs-align="center"
              vs-justify="center"
            >
              <vs-col
                vs-w="12"
                vs-type="flex"
                vs-align="flex-start"
                vs-justify="space-between"
              >
                <ModalEditarProduto
                  @update="getProdutos"
                  :produto="data[indextr]"
                />
                <ModalGerenciarMetodos
                  @update="getProdutos"
                  :produto="data[indextr]"
                />
              </vs-col>
            </vs-row>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div v-if="produtos.length == 0">
      <div class="con-colors">
        <ul>
          <li class="danger-box">
            <h2 class="p-5" style="color: white !important">
              Nenhum produto cadstrado
            </h2>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ModalCadastroProduto from "./cadastro.vue"
import ModalEditarProduto from "./editar.vue"
import ModalGerenciarMetodos from "./gerenciarMetodos.vue"

export default {
  data () {
    return {
      produtos: []
    }
  },
  methods: {
    async getProdutos () {
      this.$vs.loading()
      try {
        this.produtos = await this.$http.get(`produto`)
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  components: {
    ModalCadastroProduto,
    ModalEditarProduto,
    ModalGerenciarMetodos
  },
  mounted () {
    this.getProdutos()
  }
};
</script>

<style>
.col {
  width: auto;
}
.actions {
  width: 60px !important;
}
</style>
